import React, { useState, useEffect } from 'react';
import client from '@js/modules/httpClient/index';
import FacebookLogin from 'react-facebook-login';

export function SnsAuth() {
  const [errorText, setErrorText] = useState('');
  const [appId, setAppId] = useState('');

  useEffect(() => {
    const stateCode = 'fincf-facebook-app-id';

    client.get(`/api/v1/customer/facebook_auth/facebook_app_id?state=${stateCode}`)
      .then((response) => {
        setAppId(response.data.id);
      })
      .catch(() => {
        setAppId('');
      });
  }, []);

  function sendUserInfo(userInfo) {
    client.post('/api/v1/customer/facebook_auth', userInfo)
      .then((response) => {
        const path = response['data']['path'];
        location = `${path}`;
      })
      .catch((error) => {
        if(
          error.error?.type === 'CustomerIsExists' ||
          error.error?.type === 'ActiveRecord::RecordInvalid'
        ) {
          setErrorText(error.error.message);
        } else {
          console.log(`FinCF API Server Error: ${error}`);
        }
      });
  }

  function responseFacebook(response) {
    if(response.status != 'unknown' ) {
      if(response['email'] == undefined) {
        setErrorText('メールアドレスが登録されていないため、SNS登録ができません。');
      } else {
        sendUserInfo(response);
      }
    }
  }

  if(appId != '') {
    return (
      <>
        <FacebookLogin
          cssClass="button__sns--facebook"
          textButton=""
          appId={appId}
          autoLoad={false}
          fields="email"
          scope="public_profile, email"
          callback={responseFacebook}
          icon={<FacebookIcon />}
        />
        <div className='form-input__error'>{errorText}</div>
      </>
    );
  } else {
    return <></>;
  }
}

function FacebookIcon() {
  return <span className="icon__sns--facebook">facebookでログイン</span>;
}
